import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import Papa from "papaparse";
import JSZip from "jszip";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import Select from "@mui/material/Select";

// Material UI components
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FormControlLabel from "@mui/material/FormControlLabel";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";

// Icons
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ErrorIcon from "@mui/icons-material/Error";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { getSessionStorage } from "../../Helper";
import { API_BASE_URL } from "../../Config";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { FormControl, MenuItem, useTheme } from "@mui/material";

function PickupReport() {
  const showSidebar = useSelector((state) => state.sidebar.showSidebar);
  const [inputType, setInputType] = useState("inputDate");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];
  const [loadingImage, setLoadingImage] = useState(null);
  const [downloadButton, setDownloadButton] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [status, setStatus] = useState("All");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedCNoteNumber, setSelectedCNoteNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [rotationAngle, setRotationAngle] = useState(0);
  const [loadingZip, setLoadingZip] = useState(false);
  const [maxToDate, setMaxToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const toDateInputRef = useRef(null);

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const obj = {
    cid: getSessionStorage("cid"),
    accode: getSessionStorage("accode"),
    datefrom: fromDate.split("-").reverse().join("/"),
    dateto: toDate.split("-").reverse().join("/"),
  };

  const handleRotate = () => {
    setRotationAngle((prevAngle) => prevAngle + 90);
  };

  const handleResetRotation = () => {
    setRotationAngle(0);
  };

  // const handleDateChange = (e, setDate, isFromDate) => {
  //   const selectedDate = e.target.value;

  //   if (isFromDate) {
  //     setDate(selectedDate);
  //     const oneMonthLater = new Date(selectedDate);
  //     oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
  //     const maxDate = oneMonthLater.toISOString().split("T")[0];
  //     setMaxToDate(maxDate);
  //   } else {
  //     if (selectedDate >= fromDate && selectedDate <= maxToDate) {
  //       setDate(selectedDate);
  //     } else {
  //       console.log('Invalid date selected for "To Date".');
  //     }
  //   }
  // };

  const handleFromDateChange = (e) => {
    const selectedDate = e.target.value;
    setFromDate(selectedDate);

    const date = new Date(selectedDate);
    date.setDate(date.getDate() + 30);
    const maxDate = date.toISOString().split("T")[0];
    setMaxToDate(maxDate);
    setToDate("");
  };

  const handleToDateClick = () => {
    if (fromDate && !toDate) {
      toDateInputRef.current.value = fromDate;
      setTimeout(() => {
        toDateInputRef.current.value = "";
      }, 0);
    }
  };

  const handleToDateChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate >= fromDate && selectedDate <= maxToDate) {
      setToDate(selectedDate);
    } else {
      alert("Please select a date within 30 days from From Date");
      setToDate("");
    }
  };

  const handleFilterSubmit = async () => {
    setSelectedRows([]);
    setLoading(true);

    if (inputType === "inputDate") {
      if (fromDate && toDate) {
        if (fromDate <= toDate) {
          try {
            const response = await axios.get(`${API_BASE_URL}/pickupReq/getPickupRequestData`, {
              params: {
                cid: getSessionStorage("cid"),
                username: getSessionStorage("accode"),
                status: status,
                dateFrom: fromDate.split("-").reverse().join("/"),
                dateTo: toDate.split("-").reverse().join("/"),
              },
            });

            const data = response.data || [];

            if (data.length === 0) {
              Swal.fire({
                icon: "info",
                title: "No Data Found !!",
                timer: 1500,
                showConfirmButton: false,
              });

              setFilteredData([]);
              setDownloadButton(false);
              return;
            }

            // const transformedData = data.map((item) => [
            //   item.REQUESTNO,
            //   item.BRANCHS,
            //   item.DOCNO,
            //   item.PICKPINCODE,
            //   item.TOTALPCS,
            //   item.REASONS,
            //   item.PICKUPTYPE,
            // ]);

            setFilteredData(data);
            setDownloadButton(true);
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Error fetching data",
              text: error.message,
              timer: 930,
              showConfirmButton: false,
            });
          } finally {
            setLoading(false);
          }
        } else {
          setErrorModal(true);
          setTimeout(() => setErrorModal(false), 2000);
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please select both From Date and To Date",
          timer: 930,
          showConfirmButton: false,
        });
        setLoading(false);
      }
    }
  };

  const handleInputTypeChange = (type) => {
    setInputType(type);
  };

  const handleAllRowsCheckboxChange = () => {
    if (selectedRows.length === filteredData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows([...Array(filteredData.length).keys()]);
    }
  };

  // Status filter handler
  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setStatus(selectedStatus);

    if (!selectedStatus || selectedStatus === "All") {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter((item) => {
        // Map status based on PICKUPTYPE
        let itemStatus = "";
        if (item.PICKUPTYPE === "Done") {
          itemStatus = "Completed";
        } else if (item.PICKUPTYPE === "Not") {
          itemStatus = "NotPickup";
        } else if (item.PICKUPTYPE === " " || !item.PICKUPTYPE) {
          itemStatus = "Pending";
        } else if (item.PICKUPTYPE === "Cancell") {
          itemStatus = "Cancell";
        }
        return itemStatus === selectedStatus;
      });
      setFilteredData(filtered);
    }
  };

  const handleDownloadExcel = async () => {
    if (!fromDate || !toDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From Date and To Date before downloading Excel.",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (fromDate > toDate) {
      setErrorModal(true);
      setTimeout(() => setErrorModal(false), 2000);
      return;
    }

    try {
      setLoading(true);

      // 🔹 API call again for Excel data
      const response = await axios.get(`${API_BASE_URL}/pickupReq/getPickupRequestHistory`, {
        params: {
          cid: getSessionStorage("cid"),
          username: getSessionStorage("accode"),
          status: status,
          dateFrom: fromDate.split("-").reverse().join("/"),
          dateTo: toDate.split("-").reverse().join("/"),
        },
      });

      const excelData = response.data || [];

      if (excelData.length === 0) {
        Swal.fire({
          icon: "info",
          title: "No Data Found !!",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Pickup Report");

      // Header
      worksheet.addRow([
        "Cust. Ref. No",
        "Challan",
        "Pickup PinCode",
        "Consignor Name",
        "From Store Code",
        "Req. Pcs",
        "To Store Code",
        "Request No",
        "Request Date",
        "Act. Pcs",
        "Status",
        "Sub-Status (Reason)",
        "CNote No",
        "Prs Date",
      ]);

      worksheet.getRow(1).font = {
        bold: true,
      };

      // 🔹 Use API response instead of filteredData
      excelData.forEach((row) => {
        worksheet.addRow([
          row.CUSTREFNO || "",
          row.CHANNEL || "",
          row.PICKPINCODE || "",
          row.PICKPERSONNAME || "",
          row.PICKSITECODE || "",
          row.TOTALPCS || "",
          row.DELSITECODE || "",
          row.REQUESTNO || "",
          row.REQUESTDATE || "",
          row.ACTPCS || "",
          row.STATUS || "",
          row.REASONS || "",
          row.CNOTENO || "",
          row.PRSDATE || "",
        ]);
      });

      // Column widths
      worksheet.columns = [
        { width: 12 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 12 },
        { width: 10 },
        { width: 12 },
        { width: 10 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 18 },
        { width: 15 },
        { width: 15 },
      ];

      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileName = `Pickup_Report_${fromDate}_to_${toDate}.xlsx`;

      saveAs(blob, fileName);

      Swal.fire({
        icon: "success",
        title: "Download Started",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Excel API Error:", error);

      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: error.response?.data?.message || error.message,
        timer: 1500,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setSelectedImage("");
    setModalVisible(false);
  };

  // Modal style
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: 900,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    outline: "none",
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        className={`mt-[24%] sm:mt-10 md:mt-0 lg:mt-0 2xl:mt-0 h-[80%] ${
          showSidebar
            ? "transition-all transition-slowest ease ml-20 lg:ml-[18%]"
            : "transition-all transition-slowest ease"
        }`}
      >
        <Card sx={{ p: 2, boxShadow: 3, mt: 3 }}>
          {inputType === "inputDate" && (
            <MDBox display="flex" flexWrap="wrap" alignItems="center" mb={3}>
              <MDBox width={{ xs: "100%", sm: "30%", lg: "20%" }} mr={2}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  From Date <span style={{ color: "red" }}>*</span>
                </MDTypography>
                {/* <MDInput
                  type="date"
                  fullWidth
                  value={fromDate}
                  onChange={(e) => handleDateChange(e, setFromDate, true)}
                  max={currentDate}
                /> */}
                <MDInput
                  type="date"
                  fullWidth
                  value={fromDate}
                  onChange={handleFromDateChange}
                  max={currentDate}
                />
              </MDBox>
              <MDBox width={{ xs: "100%", sm: "30%", lg: "20%" }} mr={2}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  To Date <span style={{ color: "red" }}>*</span>
                </MDTypography>
                {/* <MDInput
                  type="date"
                  fullWidth
                  value={toDate}
                  onChange={(e) => handleDateChange(e, setToDate)}
                  max={maxToDate}
                  min={fromDate}
                /> */}
                <MDInput
                  type="date"
                  inputRef={toDateInputRef}
                  value={toDate}
                  onChange={handleToDateChange}
                  onClick={handleToDateClick}
                  min={fromDate}
                  max={maxToDate}
                  fullWidth
                />
              </MDBox>

              <MDBox
                width={{ xs: "100%", sm: "20%", lg: "10%" }}
                mt={2}
                mr={2}
                mb={{ xs: 2, sm: 0 }}
              >
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  Status <span style={{ color: "red" }}>*</span>
                </MDTypography>
                <FormControl fullWidth required sx={{ height: 45, mb: 2 }}>
                  <Select
                    displayEmpty
                    value={status}
                    onChange={handleStatusChange}
                    renderValue={(selected) => (selected ? selected : <span>Status</span>)}
                    sx={{ height: 56 }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 300, // Limit dropdown height
                        },
                      },
                    }}
                  >
                    <MenuItem value="All" sx={{ minHeight: 48 }}>
                      All
                    </MenuItem>
                    <MenuItem value="Pending" sx={{ minHeight: 48 }}>
                      Pending
                    </MenuItem>
                    <MenuItem value="Completed" sx={{ minHeight: 48 }}>
                      Completed
                    </MenuItem>
                    <MenuItem value="NotPickup" sx={{ minHeight: 48 }}>
                      Not Pickup
                    </MenuItem>
                    <MenuItem value="Cancell" sx={{ minHeight: 48 }}>
                      Cancelled
                    </MenuItem>
                  </Select>
                </FormControl>
              </MDBox>

              <MDBox display="flex" gap={2} mt={4} flexWrap="wrap">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={handleFilterSubmit}
                  startIcon={<DateRangeIcon />}
                >
                  Show
                </MDButton>

                <MDButton
                  variant="gradient"
                  color="success"
                  onClick={handleDownloadExcel}
                  startIcon={<FileDownloadIcon />}
                  // disabled={filteredData.length === 0}
                >
                  Excel
                </MDButton>
              </MDBox>
            </MDBox>
          )}

          {loading && (
            <MDBox display="flex" justifyContent="center" p={3}>
              <CircularProgress color="info" />
            </MDBox>
          )}

          <MDBox>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: 500,
                bgcolor: isDark ? "#121212" : "#fff",
              }}
            >
              <Table
                sx={{
                  "& .MuiTableCell-root": {
                    color: "text.primary",
                  },
                }}
              >
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Request No</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Pickup PinCode</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Pickup Branch</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Cnote No</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Req PCS</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Act PCS</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Total Box</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Reason</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                </TableRow>

                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow key={index}>
                      <>
                        <TableCell
                          sx={{
                            color: isDark ? "#ffffff !important" : "#344767 !important",
                          }}
                        >
                          {row.REQUESTNO}
                        </TableCell>
                        <TableCell>{row.PICKPINCODE}</TableCell>
                        <TableCell>{row.PICKUPBRANCH}</TableCell>
                        <TableCell>{row.CNOTENO}</TableCell>
                        <TableCell>{row.REQPCS}</TableCell>
                        <TableCell>{row.ACTPCS}</TableCell>
                        <TableCell>{row.TOTALBOX}</TableCell>
                        <TableCell>{row.REASONS}</TableCell>
                        <TableCell>{row.STATUS}</TableCell>
                      </>
                    </TableRow>
                  ))}

                  {filteredData.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No Records Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </MDBox>

          <Modal open={errorModal} onClose={() => setErrorModal(false)}>
            <Box sx={modalStyle}>
              <MDTypography variant="h6" component="h2" mb={2}>
                Error
              </MDTypography>
              <MDBox display="flex" alignItems="center">
                <ErrorIcon color="error" sx={{ mr: 1 }} />
                <MDTypography>From Date cannot be greater than To Date</MDTypography>
              </MDBox>
            </Box>
          </Modal>

          {errorMessage && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errorMessage}
            </Alert>
          )}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default PickupReport;
